import { UpdatableModel } from '../updatable-model';

export class ListData<T> extends UpdatableModel<ListData<T>> {
  data: T[];
  count: number;
  metadata: any;
}
